import { JobStatus, PartFinderActivityEntry, PartFinderBatch, PartFinderReport } from '@/api/generatedApi';

export type UnifiedRow =
  | { id: string; kind: 'report'; path: string[]; createdAt?: string; report: PartFinderReport }
  | { id: string; kind: 'batch'; path: string[]; createdAt?: string; batch: PartFinderBatch };

export const isInProgress = (status: JobStatus): boolean =>
  status === JobStatus.PENDING || status === JobStatus.RUNNING;

export const isRetryable = (status: JobStatus): boolean =>
  status === JobStatus.FAILED || status === JobStatus.CANCELLED;

export const isAnyActivityInProgress = (entries: PartFinderActivityEntry[]): boolean =>
  entries.some(entry =>
    entry.type === 'batch' ? isInProgress(entry.batch.status) : isInProgress(entry.report.status)
  );

export const buildUnifiedRows = (
  entries: PartFinderActivityEntry[],
  childrenByBatch: Record<string, UnifiedRow[]>
): UnifiedRow[] => {
  const result: UnifiedRow[] = [];
  for (const entry of entries) {
    if (entry.type === 'batch') {
      const rowId = `batch-${entry.batch.id}`;
      result.push({ id: rowId, kind: 'batch', path: [rowId], createdAt: entry.batch.createdAt, batch: entry.batch });
      const children = childrenByBatch[rowId];
      if (children) result.push(...children);
    } else {
      const rowId = `report-${entry.report.id}`;
      result.push({
        id: rowId,
        kind: 'report',
        path: [rowId],
        createdAt: entry.report.createdAt,
        report: entry.report,
      });
    }
  }
  return result;
};
